import React from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import ClearIcon from '@material-ui/icons/Clear';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';

import useStyles from './styles';

CustomSearchAutoComplete.defaultProps = {
  onChange: null,
  onClear: null,
  onSubmit: null,
  placeholder: '',
  value: '',
  fetch: null,
};

export default function CustomSearchAutoComplete(props) {
  const load = React.useRef(true);
  const [reload, setReload] = React.useState(false);
  const [state, setState] = React.useState({ data: [] });

  const [value, setValue] = React.useState('');
  const classes = useStyles();

  function componentDidMount() {
    if (load.current) {
      if (props.fetch) {
        props.fetch().then(onSuccess).catch(onFailure);
      }
    }
    return function componentWillUnmount() {
      load.current = false;
    };
  }

  function onReloadChanged() {
    if (reload) {
      if (props.onChange) {
        props.onChange(value);
      }
    }
    return function reloadChanged() { setReload(false); };
  }

  function onPropsReload() {
    if (props.fetch) {
      props.fetch().then(onSuccess).catch(onFailure);
    }
    return function propsReload() { };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onReloadChanged, [reload]);
  React.useEffect(onPropsReload, [props.reload]);

  function onSuccess(response) {
    if (load.current && response.data) {
      setState(response.data);
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      // setAlert({ open: true, message: error.message });
    }
  }
  // const [value, setValue] = React.useState(props.value);

  // function handleOnClick(event) {
  //   event.preventDefault();
  //   setValue('');
  //   props.onChange(event);
  // }

  // function handleOnChange(event) {
  //   event.preventDefault();
  //   setValue(event.target.value);
  //   if (props.onChange) {
  //     props.onChange(event);
  //   }
  // }

  function handleOnChange(event, value, reason) {
    event.preventDefault();
    setValue(value);
    if (reason === 'select-option') {
      setReload(true);
    }
  }

  function handleInputChange(event, value) {
    if (event) {
      event.preventDefault();
    }
    setValue(value);
    if (value === '') {
      setReload(true);
    }
  }

  function handleKeyDown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      setReload(true);
    }
  }

  return (
    <Paper
      component='form'
      className={classes.paper}
    >
      <Autocomplete
        className={classes.autocomplete}
        id={"auto-complete"}
        // autoComplete={true}
        // autoHighlight={true}
        // open={false}
        clearOnBlur={false}
        clearOnEscape={true}
        clearText={'Limpar'}
        disableClearable={true}
        disableListWrap={true}
        disablePortal={true}
        forcePopupIcon={false}
        handleHomeEndKeys={false}
        loading={false}
        fullWidth={true}
        loadingText={'Carregando...'}
        noOptionsText={props.noOptionsText || 'Sem opções'}
        openOnFocus={true}
        size={'small'}
        onInputChange={handleInputChange}
        onChange={handleOnChange}
        onKeyDown={handleKeyDown}
        inputValue={value || props.value || ''}
        options={props.options || state.data.map((item) => item.name)}
        renderInput={(params) => (
          <Grid container spacing={1} alignItems='center'>
            <Grid item xs>
              <TextField
                {...params}
                placeholder={props.placeholder || ''}
                fullWidth
                label={props.placeholder || ''}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
              />
            </Grid>
            { value &&
              <Grid item>
                <IconButton
                  type='button'
                  className={classes.iconButton}
                  aria-label='clear'
                  onClick={() => { setValue(''); setReload(true); }}
                >
                  <ClearIcon />
                </IconButton>
              </Grid>
            }
            <Grid item>
              <IconButton
                type='button'
                className={classes.iconButtonSearch}
                aria-label='search'
                size='small'
                onClick={() => { setReload(true); }}
              >
                <SearchIcon />
              </IconButton>
            </Grid>
          </Grid>
        )}
      />
    </Paper>
  )
}


